<template>
  <span>
    <a href='#' v-if="this.params.data.contentType != 'External Resource'" @click.prevent="downloadArtifact()" download>{{ this.params.value }}</a>
    <a :href='this.params.data.externalUrl' target="_blank" v-if="this.params.data.contentType == 'External Resource'" download>{{ this.params.value }}</a>
  </span>
</template>

<script lang="js">
import Vue from 'vue';
import LearnerArtifactsStore from '@/modules/ees/store/LearnerArtifactStore';

export default Vue.extend({
  components: {
  },
  data() {
    return {
    }
  },
  methods: {
    downloadArtifact() {
      LearnerArtifactsStore.actions.downloadArtifact(this.params.data.artifactId, this.params.data.name)
    }
  }
})
</script>